import { render, staticRenderFns } from "./d-search-results-group.vue?vue&type=template&id=3db80113&scoped=true&"
import script from "./d-search-results-group.vue?vue&type=script&lang=js&"
export * from "./d-search-results-group.vue?vue&type=script&lang=js&"
import style0 from "./d-search-results-group.vue?vue&type=style&index=0&id=3db80113&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db80113",
  null
  
)

export default component.exports